export enum PIICategory {
    ContactInfo = "CONTACT_INFO",
    Identifiers = "IDENTIFIERS",
    UserContent = "USER_CONTENT",
}

export enum PIIItem {
    Name = "NAME",
    EmailAddress = "EMAIL_ADDRESS",
    PhoneNumber = "PHONE_NUMBER",
    UserId = "USER_ID",
    DeviceId = "DEVICE_ID",
    CustomerSupport = "CUSTOMER_SUPPORT",
}
